<template>
    <div>
        <fieldset>
            <legend>Grupo 3</legend>
            <div class="row">
                <div class="col s12 m12">
                    <div class="card-panel amber lighten-3">
                        <span>As informações prestadas a seguir devem ser exclusivamente as de caráter artístico-cultural constantes no currículo lattes.
                        </span>
                    </div>
                </div>
            </div>
            <fieldset>

                <legend>Atuação Artístico-Cultural</legend>
                <div class="row">
                    <div class="input-field col s5 m5 l5 xl5" >
                        <select :disabled="!editable"   name="atuacaoCultural"  >
                            <option value="" selected>Sem Atuação</option>
                            <option 
                            v-for="atuacao in this.filterAtuacaoArtistica" 
                            :value="atuacao.nome"
                            :key="atuacao.id"
                            >{{atuacao.nome}}</option>
                        </select>
                    </div>
                    
                    <div class="input-field col s1 m1 l1 xl1"  >
                        <input type="number" id="qtd"  name="qtdCultural" min='1' value='1' />
                        <label for="qtd">Quantidade</label>
                    </div>
                    <div class="file-field input-field col s6 m6 l6 xl6">
                        <div class="btn">
                            <span>Divulgação do material</span>
                            <input id="pdfAtuacao_atuacaoCultural" type="file" name="pdfAtuacao_atuacaoCultural" ref="pdfAtuacao_atuacaoCultural" accept="application/pdf" >
                        </div>
                        <div class="file-path-wrapper">
                            <input class="file-path validate"  name="pdfAtuacao_atuacaoCultural" type="text">
                        </div>
                    </div>
				</div>
                    <div class="row">
                    <div class="col s2 m2 l2 xl2">
                        <button type="button" class="btn" :disabled="!editable" 
                        @click="btnAdicionarAtuacaoOnClick($event,'artístico-cultural')"
                         name="btnAdicionarAtuacoes">Adicionar</button>
                    </div>
                      <div v-if="project.curriculo.atuacoes">
                        <atuacao :atuacaos="atuacaos" :tipo="'artístico-cultural'" :editable="editable"/>
                      </div>
                </div>
            </fieldset>
			
			<fieldset>
                <legend>Produção Científica</legend>
                <div class="row">
                    <div class="input-field col s5 m5 l5 xl5" >
                        <select :disabled="!editable"   name="producaoCientifica"  >
                            <option value="" selected>Sem Atuação</option>
                            <option 
                            v-for="atuacao in this.filterProducaoCientifica" 
                            :value="atuacao.nome"
                            :key="atuacao.id"
                            >{{atuacao.nome}}</option>
                        </select>
                    </div>
                    
                    <div class="input-field col s1 m1 l1 xl1"  >
                        <input type="number" id="qtd"  name="qtdCientifica" min='1' value='1' />
                        <label for="qtd">Quantidade</label>
                    </div>
                    <div class="file-field input-field col s6 m6 l6 xl6">
                        <div class="btn">
                            <span>Divulgação do material</span>
                            <input id="pdfAtuacao_producaoCientifica" type="file" name="pdfAtuacao_producaoCientifica" ref="pdfAtuacao_producaoCientifica" accept="application/pdf" >
                        </div>
                        <div class="file-path-wrapper">
                            <input class="file-path validate"  name="pdfAtuacao_producaoCientifica" type="text">
                        </div>
                    </div>
				</div>
                <div class="row">
                    <div class="col s2 m2 l2 xl2">
                        <button type="button" class="btn" :disabled="!editable" 
                        @click="btnAdicionarAtuacaoOnClick($event,'produção científica')"
                         name="btnAdicionarAtuacoes">Adicionar</button>
                    </div>
                      <div v-if="project.curriculo.atuacoes">
                        <atuacao :atuacaos="atuacaos" :tipo="'produção científica'" :editable="editable"/>
                      </div>
                </div>
            </fieldset>
			

            <fieldset>
                <legend>Atuação na SIAC</legend>
                <div class="row">
                    <div class="input-field col s5 m5 l5 xl5">
                        <select  name="atuacaoSIAC" :disabled="!editable"  >
                            <option value="">Sem Atuação</option>
                            <option  v-for="atuacao in this.filterAtuacaoSIAC"
                                :value="atuacao.nome"
                                :key="atuacao.id">{{atuacao.nome}}</option>
                        </select>
                    </div>

                    <div>
                        <div class="input-field col s1 m1 l1 xl1">
                            <input id="qtdSIAC" type="number" :disabled="!editable"   value='1' name="qtdSIAC"/>
                            <label for="qtdSIAC">Quantidade</label>
                        </div>
						<div class="file-field input-field col s6 m6 l6 xl6">
                        <div class="btn">
                            <span>Comprovante</span>
                            <input id="pdfAtuacao_SIAC" type="file" name="pdfAtuacao_SIAC" ref="pdfAtuacao_SIAC" accept="application/pdf" >
                        </div>
                        <div class="file-path-wrapper">
                            <input class="file-path validate"  name="pdfAtuacao_SIAC" type="text">
                        </div>
                    </div>
                    </div>
				</div>
				
				<div class="row">
					<div class="col s2 m2 l2 xl2 ">
                        <button type="button" class="btn" :disabled="!editable"  @click="btnAdicionarAtuacaoOnClick($event,'SIAC')" name="btnAdicionarAtuacoes">Adicionar</button>
                    </div>
				</div>
                <div class="row">
                    <div v-if="project.curriculo.atuacoes">
                        <atuacao :atuacaos="atuacaos"  ref="atuacao" :tipo="'SIAC'" :editable="editable"/>
                    </div>
                </div>
            </fieldset>
            
        </fieldset>
    </div>
</template>
<script>
import Atuacao from '../atuacoes/Atuacao.vue';
import { validatePDF } from '../../utils';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
    name:'Group3',
    props:[
        'editable',
        'atuacaos'
    ],
    components:{
        Atuacao
    },
    
    data(){
        return{
            atuacoes:JSON.parse(this.atuacaos),
            
        }
    },
    computed:{
        ...mapState(['project']),
        filterAtuacaoSIAC(){return this.atuacoes.filter( atuacao=>atuacao.tipo == 'SIAC')},
        filterAtuacaoArtistica(){return this.atuacoes.filter(atuacao=>atuacao.tipo == 'artístico-cultural')},
        filterProducaoCientifica(){return this.atuacoes.filter(atuacao=>atuacao.tipo == 'produção científica')},            
    },
    methods:{
        ...mapActions(['setProject']),
        getAtuacaoByNome(nome){
            return this.atuacoes.find( atuacao =>atuacao.nome == nome)
        },
        getAtuacaoById(id){
            return this.atuacoes.find( atuacao =>atuacao.id == id)
        },
        _limparAtuacao(tipo){
            setTimeout( ()=>{
                if (tipo == 'artístico-cultural') 
					$("input[name='pdfAtuacao_atuacaoCultural']").val("");
				else if (tipo == 'produção científica') 
					$("input[name='pdfAtuacao_producaoCientifica']").val("");
				else if (tipo == 'SIAC') 
					$("input[name='pdfAtuacao_SIAC']").val("");				
                $("select[name='atuacaoSelect']").val("").change();
            },1000);
            
        },
        getLastElement(){
            return this.project.curriculo.atuacoes[this.project.curriculo.atuacoes.length-1];
        },
        getLastIndexOfAtuacoes(){
            return this.project.curriculo.atuacoes.length-1;
        },
        btnAdicionarAtuacaoOnClick(e,tipo){
            let qtd=0;
            let nomeAtuacao="";
            if(tipo == 'SIAC'){
                nomeAtuacao=$("select[name='atuacaoSIAC']").val();
                qtd=$("input[name='qtdSIAC']").val();
            }
            else if (tipo == 'artístico-cultural') {
                nomeAtuacao=$("select[name='atuacaoCultural']").val();
                qtd=$("input[name='qtdCultural").val();
			}
			else {
				nomeAtuacao=$("select[name='producaoCientifica']").val();
                qtd=$("input[name='qtdCientifica").val();
			}
            if(!nomeAtuacao || !nomeAtuacao == 'Sem Atuação'){
                showMsg('Por favor, selecione uma atuação.')
                return false;
            }
            if(Number(qtd) <= 0){
                showMsg('Por favor, selecione uma quantiade superior a 0.');
                return false;
            }

            if(this.addAtuacao(nomeAtuacao,qtd,tipo)){
                var spinner=document.getElementById('spinner');
                spinner.style.display=null;
                let formData =new FormData();
                let atuacao=this.getLastElement();
                formData.append("atuacao",JSON.stringify(atuacao));
                formData.append('curriculo_id',this.project.curriculo.id);
                if (tipo == 'artístico-cultural') 
                    formData.append("pdfAtuacao", this.$refs.pdfAtuacao_atuacaoCultural.files[0]);
                else if (tipo == 'produção científica') 
                    formData.append("pdfAtuacao", this.$refs.pdfAtuacao_producaoCientifica.files[0]);
				else if (tipo == 'SIAC') 
                    formData.append("pdfAtuacao", this.$refs.pdfAtuacao_SIAC.files[0]);
                
				
                    
                $.ajax({
                    headers:{
                        'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                    },
                    url:"/curriculos/atuacoes/",
                    data:formData,
                    type:"post",
                    contentType:false,
                    processData:false,
                    success:(response, status)=>{
                        showMsg(response.msg,200)
                        let lastElement=this.getLastElement();
                        lastElement['id']=response['id'];
                        this.project.curriculo.atuacoes[this.getLastIndexOfAtuacoes]=lastElement;
                        
                        this.setProject(this.project);
                        setTimeout( ()=>{
                            this.$children.forEach( c => c.$forceUpdate());
                            this._limparAtuacao();
                        },1000);
                        spinner.style.display='none';
                    },
                    error:(response)=>{
                        spinner.style.display='none';
                        showMsg(response.responseText,response.status);
                        this.$children.atuacao.btnRemoverOnClick(e,this.getLastElement().id);
                        
                        
                    }
                });
            }
            this._limparAtuacao(tipo);
        
        },
        addAtuacao(nomeAtuacao,qtd,tipo){
            let existe=this.existeAtuacaoDuplicada(nomeAtuacao);
            if(Number(existe) == -1){
                showMsg('Por favor, faça o upload do lattes primeiro.',500);
                return false;
            }
            else if(!existe){
                if (tipo == 'artístico-cultural' && this.$refs.pdfAtuacao_atuacaoCultural.files[0] &&! validatePDF(this.$refs.pdfAtuacao_atuacaoCultural.files[0])) {
                    showMsg("Selecione um arquivo PDF de até 5 MB",400);
                        return false;
                } else if (tipo == 'produção científica' && this.$refs.pdfAtuacao_producaoCientifica.files[0] &&! validatePDF(this.$refs.pdfAtuacao_producaoCientifica.files[0])) {
                    showMsg("Selecione um arquivo PDF de até 5 MB",400);
                        return false;
                }
                let atuacao={};
                atuacao.atuacao=this.getAtuacaoByNome(nomeAtuacao);
                atuacao.atuacao_id=atuacao.atuacao.id;
                atuacao.curriculo_id=this.project.curriculo.id;
                atuacao.quantidade=qtd;
                atuacao.edital_id=this.project.curriculo.edital.id;
                
                if (tipo == 'artístico-cultural' && this.$refs.pdfAtuacao_atuacaoCultural.files[0])
                    atuacao['pdf']=this.$refs.pdfAtuacao_atuacaoCultural.files[0].name;
                else if (tipo == 'produção científica' && this.$refs.pdfAtuacao_producaoCientifica.files[0])
                    atuacao['pdf']=this.$refs.pdfAtuacao_producaoCientifica.files[0].name;
                else if (tipo == 'SIAC' && this.$refs.pdfAtuacao_SIAC.files[0])
                    atuacao['pdf']=this.$refs.pdfAtuacao_SIAC.files[0].name;    
                this.project.curriculo.atuacoes.push(atuacao);
                this.setProject(this.project);
                return true;
            }
            else{
                showMsg('Atuação já inserida!');
                return false;
            }
                
            
        },
        existeAtuacaoDuplicada(nome){
            if(this.project.curriculo.lattes)
                return this.project.curriculo.atuacoes.some( atuacao => atuacao.atuacao.nome == nome);
            return -1;
        },
    }

}
</script>